<template>
  <teleport to="body">
    <div class="adm-modal-backdrop" @mousedown.self="close">
      <div class="adm-modal" :class="`adm-modal--${size}`" role="dialog" aria-modal="true" :aria-label="title">
        <header class="adm-modal__header">
          <div>
            <h3 class="adm-modal__title">{{ title }}</h3>
            <p v-if="subtitle" class="adm-modal__subtitle">{{ subtitle }}</p>
          </div>
          <button type="button" class="adm-icon-btn" aria-label="Close" :disabled="busy" @click="close">
            <i class="fas fa-times"></i>
          </button>
        </header>
        <div class="adm-modal__body">
          <slot />
        </div>
        <footer v-if="$slots.footer" class="adm-modal__footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </teleport>
</template>

<script>
// Open modals, innermost last: Escape closes only the top one and the page
// stays scroll-locked until the last one closes.
const openModals = [];

export default {
  name: "AdminModal",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    size: { type: String, default: "md" }, // sm | md | lg
    busy: { type: Boolean, default: false },
  },
  emits: ["close"],
  methods: {
    close() {
      if (!this.busy) this.$emit("close");
    },
    onKey(event) {
      if (event.key === "Escape" && openModals[openModals.length - 1] === this) this.close();
    },
  },
  mounted() {
    openModals.push(this);
    document.addEventListener("keydown", this.onKey);
    document.body.classList.add("adm-modal-open");
  },
  beforeUnmount() {
    openModals.splice(openModals.indexOf(this), 1);
    document.removeEventListener("keydown", this.onKey);
    if (!openModals.length) document.body.classList.remove("adm-modal-open");
  },
};
</script>
